import { helper } from '@ember/component/helper';
import _fromNow from 'scaleflow/utils/from-now';

export default helper(function fromNow([date] /*, named*/) {
  return _fromNow(date);
});
